import { FormControlLabel, RadioGroup, Radio } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import TextField from 'components/TextField';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles.module.scss';

const CustomRadio = withStyles({
  root: {
    color: '#9277FF',
    '&$checked': {
      color: '#9277FF'
    }
  },
  checked: {}
})((props) => <Radio color='default' {...props} />);

class Question extends React.Component {
  constructor(props) {
    super(props);
    const { question, option1, option2, option3, option4, option5, correct } = this.props;
    this.state = {
      question: question || '',
      option1: option1 || '',
      option2: option2 || '',
      option3: option3 || '',
      option4: option4 || '',
      option5: option5 || '',
      correct: correct || '1'
    };
  }

  handleChange = ({ target: { name, value } }) => {
    const { onChange } = this.props;
    this.setState({ [name]: value });
    onChange(name, value);
  };

  render() {
    const { question, option1, option2, option3, option4, option5, correct } = this.state;
    const { showFifth } = this.props;
    return (
      <div className={styles.addQuestionContainer}>
        <div className={styles.question}>
          <div className={styles.label}>Question</div>
          <TextField
            multiline='on'
            value={question}
            onChange={this.handleChange}
            name='question'
            placeholder='Enter the question'
          />
        </div>
        <div className={styles.options}>
          <div className={styles.label}>Options</div>
          <TextField
            value={option1}
            onChange={this.handleChange}
            name='option1'
            placeholder='Enter first option'
          />
          <TextField
            value={option2}
            onChange={this.handleChange}
            name='option2'
            placeholder='Enter second option'
          />
          <TextField
            value={option3}
            onChange={this.handleChange}
            name='option3'
            placeholder='Enter third option'
          />
          <TextField
            value={option4}
            onChange={this.handleChange}
            name='option4'
            placeholder='Enter fourth option'
          />
          {showFifth && (
            <TextField
              value={option5}
              onChange={this.handleChange}
              name='option5'
              placeholder='Enter fifth option (optional)'
            />
          )}
        </div>
        <div className={styles.correctOption}>
          <div className={styles.label}>Choose the correct option</div>
          <RadioGroup row name='correct' value={correct} onChange={this.handleChange}>
            <FormControlLabel
              classes={{ label: styles.radioLabel }}
              value='1'
              control={<CustomRadio />}
              label='Option 1'
            />
            <FormControlLabel
              classes={{ label: styles.radioLabel }}
              value='2'
              control={<CustomRadio />}
              label='Option 2'
            />
            <FormControlLabel
              classes={{ label: styles.radioLabel }}
              value='3'
              control={<CustomRadio />}
              label='Option 3'
            />
            <FormControlLabel
              classes={{ label: styles.radioLabel }}
              value='4'
              control={<CustomRadio />}
              label='Option 4'
            />
            {showFifth && (
              <FormControlLabel
                classes={{ label: styles.radioLabel }}
                value='5'
                control={<CustomRadio />}
                label='Option 5'
              />
            )}
          </RadioGroup>
        </div>
      </div>
    );
  }
}

Question.propTypes = {
  question: PropTypes.string,
  option1: PropTypes.string,
  option2: PropTypes.string,
  option3: PropTypes.string,
  option4: PropTypes.string,
  option5: PropTypes.string,
  correct: PropTypes.string,
  showFifth: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

Question.defaultProps = {
  question: '',
  option1: '',
  option2: '',
  option3: '',
  option4: '',
  option5: '',
  correct: '',
  showFifth: false
};

export default Question;
